<template>
  <div class="filter-sidebar mb-5">
    <div
      v-if="courseData.courseTypeSlug &&
        'classroom' != courseData.courseTypeSlug.toLowerCase() && false
        "
      class="filter-sidebar__box"
    >
      <h4>{{ $t('dates') }}</h4>
      <div class="dates">
        <div
          v-for="(session, index) in filtredSessions"
          :key="index"
          class="dates__line"
        >
          <div class="dates__row dates__row_radio">
            <div>
              <div class="custom-control custom-control_light custom-radio">
                <input
                  type="radio"
                  :id="'dates-' + session.id"
                  name="dates"
                  class="custom-control-input"
                  :value="session.id"
                  v-model="sessionId"
                  @click="showPriceBox = true"
                />
                <label
                  class="custom-control-label"
                  :for="'dates-' + session.id"
                ></label>
              </div>
            </div>
            <div>
              <span class="icon icon-date_dark"></span>{{ getSessionDate(session) }}
            </div>
            <div>
              <span class="icon icon-baloon_dark"></span>
              {{ getSessionLocation(session) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-cloak
      v-if="courseData.isIATA && false"
      class="filter-sidebar__box"
    >
      <div v-if="courseData.language && 'fr' == courseData.language.toLowerCase()">
        <h4>Services additionnels</h4>
        <div class="additional-services">
          <div class="additional-services__row">
            <div class="custom-control custom-control_light custom-checkbox">
              <input
                type="checkbox"
                id="service-1"
                class="custom-control-input"
                v-model="certificate"
              />
              <label
                class="custom-control-label white-space-normal"
                for="service-1"
              >{{ iataLabel }}</label>
            </div>
            <div v-if="courseData.priceIATA > 0">
              {{ courseData.priceIATA }} €
            </div>
            <div
              class="text-success text-uppercase small"
              v-else
            >Gratuite</div>
          </div>
        </div>
      </div>
      <div v-else>
        <h4>Additional services</h4>
        <div class="additional-services">
          <div class="additional-services__row">
            <div class="custom-control custom-control_light custom-checkbox">
              <input
                type="checkbox"
                id="service-1"
                class="custom-control-input"
                v-model="certificate"
              />
              <label
                class="custom-control-label white-space-normal"
                for="service-1"
              >{{ iataLabel }}</label>
            </div>
            <div v-if="courseData.priceIATA > 0">
              {{ courseData.priceIATA }} €
            </div>
            <div
              class="text-success text-uppercase small"
              v-else
            >Free</div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-cloak
      class="filter-sidebar__box"
      v-if="courseData.courseTypeSlug &&
        'classroom' != courseData.courseTypeSlug.toLowerCase() && false
        "
    >
      <div
        v-if="!user || user.clientType != 1"
        class="row align-items-center justify-content-between"
      >
        <div class="col">
          <h4>{{ $t('people') }}</h4>
        </div>
        <div class="col text-right">
          <div class="custom-number d-inline-flex">
            <button
              @click="qty--"
              class="custom-number__btn custom-number__btn_down"
              :disabled="qty == 1"
            ></button>
            <input
              type="text"
              v-model="qty"
            />
            <button
              @click="qty++"
              class="custom-number__btn custom-number__btn_up"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-cloak
      v-if="showPriceBox && coursePrice > 0 && false"
      class="filter-sidebar__box mb-3"
    >
      <div class="total-price">
        <div class="total-price__row">
          <div v-if="courseData.language && 'fr' == courseData.language.toLowerCase()
            ">
            Formation
          </div>
          <div v-else>Training</div>
          <div class="icon-price">
            {{ qty }}
            <div class="icon icon-cross"></div>
            {{ courseData.amountHt ? courseData.amountHt : 0 }} €
          </div>
        </div>
        <div
          v-if="certificate"
          class="total-price__row"
        >
          <div>{{ iataLabel }}</div>
          <div class="icon-price">
            {{ qty }}
            <div class="icon icon-cross"></div>
            {{ courseData.priceIATA }} €
          </div>
        </div>
        <div
          v-if="getVatPercent"
          class="total-price__row"
        >
          <div>{{ $t('vat') }} ({{ getVatPercent }})</div>
          <div class="icon-price">{{ vatValue }} €</div>
        </div>
        <div class="total-price__row total-price__row_total">
          <div>{{ $t('total') }}</div>
          <div class="icon-price">{{ total }} €</div>
        </div>
      </div>
    </div>
    <div
      v-if="monitor.visible"
      class="text-center pb-4"
    >
      <div :class="monitor.type">{{ monitor.message }}</div>
    </div>
    <div
      class="text-center"
      v-if="courseData.language && 'fr' == courseData.language.toLowerCase()"
    >
      <div
        v-if="(courseData.courseTypeSlug && 'classroom' == courseData.courseTypeSlug.toLowerCase() && coursePrice != 0) || coursePrice == 0 || true"
      >
        <a
          href="#"
          class="btn btn-primary"
          @click.stop.prevent="quoteRequest()"
        >Demande de devis</a>
      </div>
      <!-- <div v-else>
        <button
          class="btn btn-primary btn-icon w-100"
          @click.stop.prevent="addToCart()"
          :disabled="!showPriceBox"
        >
          <span class="icon icon-cart_white"></span>Ajouter au panier
        </button>
      </div> -->
    </div>
    <div
      class="text-center"
      v-else
    >
      <div
        v-if="(courseData.courseTypeSlug && 'classroom' == courseData.courseTypeSlug.toLowerCase() && coursePrice != 0) || coursePrice == 0 || true"
      >
        <a
          href="#"
          class="btn btn-primary"
          @click.stop.prevent="quoteRequest()"
        >Quote request</a>
      </div>
      <!-- <div v-else>
        <button
          class="btn btn-primary btn-icon w-100"
          @click.stop.prevent="addToCart()"
          :disabled="!showPriceBox"
        >
          <span class="icon icon-cart_white"></span>Add to cart
        </button>
      </div> -->
    </div>
    <add-to-cart-confirmation-modal></add-to-cart-confirmation-modal>
  </div>
</template>

<script>
import AddToCartConfirmationModal from './modals/AddToCartConfirmationModal.vue'
import { v4 as uuidv4 } from 'uuid'
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
export default {
  name: 'pricingBox',
  props: ['courseData', 'iataLabel'],
  components: { AddToCartConfirmationModal },
  data() {
    return {
      qty: 1,
      sessionId: '',
      showPriceBox: false,
      certificate: false,
      confirmed: false,
      filtredSessions: [],
      swal: null,
      locale: null,
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['cart', 'user', 'quoteCourse', 'quoteLanguage']),
    ...mapGetters(['isLoggedIn', 'checkTraineeRegistration']),
    coursePrice() {
      return this.courseData?.amountHt ?? 0
    },
    clientType() {
      return this.$lodash.get(this.user, 'clientType', false)
    },
    getVatPercent() {
      if (this.$lodash.get(this.courseData, 'offers[0].vat', false)) {
        return this.courseData.offers[0].vat
      } else return false
    },
    total() {
      let amountHt = 0
      if (this.courseData.amountHt != null) {
        amountHt = this.courseData.amountHt
      }
      let v = parseFloat(amountHt) * this.qty
      if (this.certificate) {
        v = v + parseFloat(this.courseData.priceIATA) * this.qty
      }
      return v.toFixed(2)
    },
    vatValue() {
      if (this.$lodash.get(this.courseData, 'offers[0].vat', false)) {
        let percent = this.courseData.offers[0].vat / 100
        return (parseFloat(this.total) * percent).toFixed(2)
      } else return false
    },
  },
  created() { },
  mounted() {
    this.locale = document.head.querySelector('meta[name="app-locale"]').content
    this.swal = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-dark',
        cancelButton: 'btn btn-dark',
      },
      buttonsStyling: false,
    })
    if (this.courseData.courseTypeSlug != 'e-learning') {
      this.filtredSessions = this.$lodash.sortBy(
        this.courseData.sessions,
        'startAt'
      )
    } else {
      let filtredSessionDates = this.$lodash.sortBy(
        this.courseData.sessions,
        'endAt'
      )
      let indexSession = filtredSessionDates.length - 1
      if (indexSession != -1) {
        this.filtredSessions.push(filtredSessionDates[indexSession])
      }
    }
  },
  methods: {
    getSessionDate(item) {
      if (this.$lodash.get(item, 'startAt', '')) {
        if (
          this.$lodash.get(this.courseData, 'courseTypeSlug', '') ===
          'e-learning'
        ) {
          return this.$moment(item.startAt).format('YYYY')
        } else {
          return this.$moment(item.startAt).format('Do MMMM ')
        }
      }
    },
    getSessionLocation(item) {
      if (this.$lodash.get(item, 'locationName', '')) {
        let loc = item.locationName
        return loc
      }
    },
    quoteRequest() {
      this.quoteCourse = this.courseData.name
      this.quoteLanguage = this.courseData.language
      window.location = '/quote-request'
    },
    addToCart() {
      let price = 0
      let data = {}
      let cartItem = this.cart.items.find((r) => r.sessionId == this.sessionId)
      let session = this.courseData.sessions.find((s) => s.id == this.sessionId)
      if (this.isLoggedIn && this.user.clientType == 1) {
        if (this.checkTraineeRegistration(session)) {
          this.swal.fire({
            text: this.$t('registredAlready'),
          })
          return
        }
      }
      if (cartItem) {
        let index = this.$lodash.findIndex(
          this.cart.items,
          (r) => r.id === cartItem.id
        )
        if (index > -1) {
          let data = {}
          data.IndexItem = index
          data.qty = this.qty
          this.$store.commit('UPDATE_QTY', data)
          this.$bus.$emit('cart.add.confirmation')
        }
        return
      }
      data.courseId = this.courseData.courseId
      data.courseName = this.courseData.name || ''
      data.courseRef = this.courseData.courseRef || ''
      data.courseTypeSlug = this.courseData.courseTypeSlug || ''
      data.iataChecked = this.certificate
      data.id = uuidv4()
      data.location = session.locationName || ''
      if (this.$lodash.get(this.courseData, 'amountHt')) {
        price = this.courseData.amountHt
      }
      data.price = price
      data.priceIATA = this.courseData.priceIATA
      data.isIATA = this.courseData.isIATA || false
      data.qty = this.qty
      data.sessionId = this.sessionId
      data.startAt = session.startAt
      data.name = session.name
      data.subTotalHT = price * this.qty
      data.trainees = []
      this.$store.commit('ADD_TO_CART', data)
      this.sessionId = null
      this.certificate = false
      this.qty = 1
      this.showPriceBox = false
      setTimeout(() => {
        this.monitor.visible = false
        this.confirmed = true
      }, 1000)
    },
  },
}
</script>
